module.exports = __webpack_public_path__ + "static/media/logo.e2a0667c.png";